import { addLanguageToPath, SupportedLanguage } from "../languages";

export const COURSE_SLUGS = [
  "socialevents",
  "jobinterviews",
  "salesmarketing",
  "educationteaching",
  "debatesnegotiations",
  "mediacontentcreation",
  "careerleadership",
] as const;

export type CourseSlug = (typeof COURSE_SLUGS)[number];

export const isCourseSlug = (slug: string): slug is CourseSlug => {
  return COURSE_SLUGS.includes(slug as CourseSlug);
};

export type CourseConfig = {
  slug: CourseSlug;
  labelKey: string;
  titleKey: string;
  descriptionKey: string;
  listDescriptionKey: string;
  coverImage: string;
};

export const COURSES: CourseConfig[] = [
  {
    slug: "socialevents",
    labelKey: "courses.socialevents.label",
    titleKey: "courses.socialevents.title",
    descriptionKey: "courses.socialevents.description",
    listDescriptionKey: "courses.socialevents.listDescription",
    coverImage: "/img/courses/social_events_cover.png",
  },
  {
    slug: "jobinterviews",
    labelKey: "courses.jobinterviews.label",
    titleKey: "courses.jobinterviews.title",
    descriptionKey: "courses.jobinterviews.description",
    listDescriptionKey: "courses.jobinterviews.listDescription",
    coverImage: "/img/courses/interview_cover.png",
  },
  {
    slug: "salesmarketing",
    labelKey: "courses.salesmarketing.label",
    titleKey: "courses.salesmarketing.title",
    descriptionKey: "courses.salesmarketing.description",
    listDescriptionKey: "courses.salesmarketing.listDescription",
    coverImage: "/img/courses/sales_cover.png",
  },
  {
    slug: "educationteaching",
    labelKey: "courses.educationteaching.label",
    titleKey: "courses.educationteaching.title",
    descriptionKey: "courses.educationteaching.description",
    listDescriptionKey: "courses.educationteaching.listDescription",
    coverImage: "/img/courses/teaching_cover.png",
  },
  {
    slug: "debatesnegotiations",
    labelKey: "courses.debatesnegotiations.label",
    titleKey: "courses.debatesnegotiations.title",
    descriptionKey: "courses.debatesnegotiations.description",
    listDescriptionKey: "courses.debatesnegotiations.listDescription",
    coverImage: "/img/courses/discussions_cover.png",
  },
  {
    slug: "mediacontentcreation",
    labelKey: "courses.mediacontentcreation.label",
    titleKey: "courses.mediacontentcreation.title",
    descriptionKey: "courses.mediacontentcreation.description",
    listDescriptionKey: "courses.mediacontentcreation.listDescription",
    coverImage: "/img/courses/media_cover.png",
  },
  {
    slug: "careerleadership",
    labelKey: "courses.careerleadership.label",
    titleKey: "courses.careerleadership.title",
    descriptionKey: "courses.careerleadership.description",
    listDescriptionKey: "courses.careerleadership.listDescription",
    coverImage: "/img/courses/career_cover.png",
  },
];

export const getCourseBySlug = (slug: string): CourseConfig | undefined => {
  return COURSES.find((course) => course.slug === slug);
};

export const getCoursePath = (
  slug: CourseSlug,
  language: SupportedLanguage
): string => {
  return addLanguageToPath(`/courses/${slug}`, language);
};

export const getCoursesPath = (language: SupportedLanguage): string => {
  return addLanguageToPath("/courses", language);
};
